import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import addIcon from "../../assets/addWhiteIcon.png";
import ModalHeader from "../../components/Header/ModalHeader";
import updateIconImg from "../../assets/updateIconImg.png";
import deleteIconImg from "../../assets/deleteIcon.png";
import DialogComponent from "../../components/Dialog";
import ModuleForm from "./ModuleForm";
import { deleteModule, getModuleFromServer } from "../../services/ModuleService";
import "./CourseModal.scss";

const getUniqueValuesByKey = (data, key) => {
  const values = data.map((item) => item[key]);
  return [...new Set(values)];
};

function ModuleView() {
  const [modules, setModules] = useState([]);
  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedModules, setSelectedModules] = useState([]);
  const [showAddModuleModal, setShowAddModuleModal] = useState(false);
  const navigate = useNavigate();
  const toast = useRef(null);

  const fetchModules = async (page, pageSize) => {
    try {
      const response = await getModuleFromServer(page, pageSize);

      const sorted = response.data.sort((a, b) => a.title.localeCompare(b.title));
      setModules(sorted);
      setPage(response.page);
      setPageSize(response.pageSize);
      setTotalCount(response.total);

    } catch (error) {
      console.error("Error fetching modules:", error);
      setModules([]);
      setTotalCount(0);
    }
  };
  useEffect(() => {
    fetchModules(page, pageSize);
  }, [page, pageSize]);

  const handleModalClose = () => {
    setShowAddModuleModal(false);
    navigate("/module?tab=list", { replace: true });
    fetchModules(page, pageSize);
  };

  const handleAddModuleClick = () => {
    setShowAddModuleModal(true);
  };
  const onFilter = (e, field) => {
    const value = e.target.value.toLowerCase();
    const newFilters = { ...filters, [field]: value };
    setFilters(newFilters);
  };
  const searchTemplate = (field) => (
    <InputText
      value={filters[field] || ""}
      onChange={(e) => onFilter(e, field)}
      placeholder={`Search ${field}`}
      className="p-column-filter"
    />
  );
  console.log("modules",modules);
  
  const filteredData =
    Object.keys(filters).length === 0
      ? modules
      : modules.filter((item) =>
          Object.keys(filters).every((key) => {
            const keys = key.split(".");
            const value = keys.reduce((acc, k) => acc?.[k], item);
            return value?.toString().toLowerCase().includes(filters[key]);
          })
        );
console.log("filteredData",filteredData);

  const handleDeleteModules = async () => {
    if (selectedModules.length === 0) {
      toast.current.show({
        severity: "warn",
        summary: "Warning",
        detail: "Please select at least one module to delete.",
        life: 3000,
      });
      return;
    }
    confirmDialog({
      message: "Are you sure you want to delete the selected Module(s)?",
      header: "Confirmation",
      icon: "pi pi-info-circle",
      accept: async () => {
        let successCount = 0;
        for (const module of selectedModules) {
          try {
            await deleteModule(module.id);
            successCount++;
          } catch (error) {
            console.error("Error deleting module:", error);
          }
        }
        if (successCount > 0) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Module(s) deleted successfully.",
            life: 3000,
          });
        }
        setSelectedModules([]);
        fetchModules(page,pageSize);
      },
    });
  };

  console.log("pagze",pageSize);
  
  const handleTablePageChange = (newPage, newPageSize) => {
    setPage(newPage);
    setPageSize(newPageSize);
  };
  return (
    <>
      <Toast ref={toast} />
      <div className="masterScreen">
                <div className="grid flex justify-content-end mb-4" style={{ marginLeft: '49.5rem'}}>
          <div className="md:col-6 col-div" />
          <div className="sm:col-12 md:col-6 button_section">
                        <div className="flex justify-content-end align-items-center mt-4 mb-2 gap-18 w-full">
              <div className="grid flex justify-content-end mb-2">
                <div className="md:col-6 col-div"></div>
                <div className="sm:col-12 md:col-6 button_section">
                  <div className="flex justify-content-end align-items-center mb-2 gap-18 w-full">
                    <div className="flex gap-2">
                      <Button
                        className="master-updateBtn"
                        label="Update"
                        severity="info"
                        icon={<img src={updateIconImg} alt="Update icon" />}
                        outlined
                        disabled={selectedModules.length !== 1}
                        tooltip="Update Module"
                        tooltipOptions={{ position: "bottom", event: "both" }}
                        onClick={() => {
                          if (selectedModules.length === 1) {
                            const moduleData = selectedModules[0];
                            navigate("/module?tab=edit", {
                              state: {
                                mode: "update",
                                module: moduleData,
                              },
                            });
                            setShowAddModuleModal(true);
                          }
                        }}
                      />
                      <Button
                        className="master-deleteBtn"
                        label="Delete"
                        severity="danger"
                        icon={<img src={deleteIconImg} alt="Delete icon" />}
                        outlined
                        disabled={selectedModules.length === 0}
                        onClick={handleDeleteModules}
                      />
                      <Button
                        className="addBtn"
                        label="Add New Module"
                        icon={<img src={addIcon} alt="Add icon" />}
                        disabled={selectedModules.length > 0}
                        tooltip="Add New Module"
                        tooltipOptions={{ position: "bottom", event: "both" }}
                        onClick={() => {
                          navigate("/module?tab=add");
                          handleAddModuleClick();
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <DataTable
          lazy
          className="table-viewport custom-tooltip"
          resizableColumns
          value={filteredData}
          size="small" 
          dataKey="id"
          emptyMessage="No data found."
          filterDisplay="row"
          scrollable
          scrollHeight="510px"
          paginator
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
          rows={pageSize}
          first={(page - 1) * pageSize}
          rowsPerPageOptions={[5, 10, 20, 50]}
          onPage={(e) => {
            const newPage = Math.floor(e.first / e.rows) + 1;
            const newPageSize = e.rows;
            handleTablePageChange(newPage, newPageSize);
          }}
          totalRecords={totalCount}
          selection={selectedModules}
          onSelectionChange={(e) => setSelectedModules(e.value)}
        >
          <Column selectionMode="multiple" header="Select" frozen />
          <Column field="title" header="Module Title" filter showFilterMenu={false} filterElement={() => searchTemplate("title")} />
          <Column field="description" header="Description" filter showFilterMenu={false} filterElement={() => searchTemplate("description")} />
          <Column field="Course.title" header="Course" filter showFilterMenu={false} filterElement={() => searchTemplate("Course.title")} />
        </DataTable>
        <p className="text-sm">{totalCount} Total record</p>
      </div>
      <DialogComponent
        visible={showAddModuleModal}
        onHide={handleModalClose}
        header={<ModalHeader onClose={handleModalClose} backText="Back To Module" />}
        style={{ width: "100vw", maxWidth: "1000px", height: "100vh" }}
      >
        <ModuleForm onClose={handleModalClose} />
      </DialogComponent>
      <ConfirmDialog />
    </>
  );
}

export default ModuleView;